import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import permission from './modules/permission'
import common from './modules/common'
import getters from './getters'
import VuexPersist from 'vuex-persist'
Vue.use(Vuex)
const vuexLocal = new VuexPersist({
  storage: window.sessionStorage  // 可选存储方式
})
const store = new Vuex.Store({
  modules: {
    user,
    permission,
    common
  },
  getters,
  plugins: [vuexLocal.plugin]
})

export default store
